export { Alerts as AlertsPage } from './Alerts';
